/* eslint-disable */
// settings
var MAX_SCORE_DIFFERENCE = 20;

//-- Resultados
Match.RESULT_WIN = 1;
Match.RESULT_DRAW = 0;
Match.RESULT_LOSS = -1;

//-- Suma de puntos
Match.SUM_WIN = 1;
Match.SUM_DRAW = 0.5;
Match.SUM_LOSS = 0;
Match.RONDAS = 8;

var matchesCount = 0;

function Match(round, player1, player2, result) {
    this.player1 = player1;
    this.player2 = player2;
    this.round = round;
    this.result = result;

    this.player1.addMatch(this);
    this.player2.addMatch(this);
    matchesCount++;
    console.log(
        matchesCount,
        player1.getMatchesWhite(),
        player1.getMatchesBlack(),
        player1.name,
        "vs",
        player2.getMatchesWhite(),
        player2.getMatchesBlack(),
        player2.name,
        "\t",
        result == Match.RESULT_WIN
            ? "1-0"
            : result == Match.RESULT_LOSS
                ? "0-1"
                : "½",
        "\t",
        player1.score,
        ":",
        player2.score
    );
}

Match.randomResult = function () {
    return (
        Math.floor(
            Math.random() * (Match.RESULT_WIN - Match.RESULT_LOSS + 1)
        ) + Match.RESULT_LOSS
    );
};

function Player(name, score, elo) {
    this.name = name;
    this.elo = elo;
    this.score = 0;
    this.buchholz = 1;
    this.wins = 0;
    this.losses = 0;
    this.draws = 0;
    this.notpair = 0;
    this.matches = [];
}

Player.prototype.deleteMatch = function (match) {
    this.matches.pop(match);

    if (match.result == Match.RESULT_DRAW) {
        this.draws--;
        this.score -= Match.SUM_DRAW;
    } else {
        if (match.player1 == this) {
            if (match.result == Match.RESULT_WIN) {
                this.wins--;
                this.score -= Match.SUM_WIN;
            } else {
                this.wins++;
                this.score -= Match.SUM_LOSS;
            }
        } else {
            if (match.result == Match.RESULT_LOSS) {
                this.wins--;
                this.score -= Match.SUM_WIN;
            } else {
                this.wins++;
                this.score -= Match.SUM_LOSS;
            }
        }
    }
};

Player.prototype.addMatch = function (match) {
    this.matches.push(match);

    if (match.result == Match.RESULT_DRAW) {
        this.draws++;
        this.score += Match.SUM_DRAW;
    } else {
        if (match.player1 == this) {
            if (match.result == Match.RESULT_WIN) {
                this.wins++;
                this.score += Match.SUM_WIN;
            } else {
                this.wins--;
                this.score += Match.SUM_LOSS;
            }
        } else {
            if (match.result == Match.RESULT_LOSS) {
                this.wins++;
                this.score += Match.SUM_WIN;
            } else {
                this.wins--;
                this.score += Match.SUM_LOSS;
            }
        }
    }
};

Player.prototype.popMatch = function (round) {
    for (var i = 0; i < this.matches.length; i++) {
        var match = this.matches[i];

        if (match && match.round == round) {
            console.log('borro match', match.player1.name, 'vs', match.player2.name);
            match.player1.deleteMatch(match);
            match.player2.deleteMatch(match);
        }
    }
};

Player.prototype.hasPlayedAgainst = function (player) {
    if (this == player)
        return false;
    for (var i = 0; i < this.matches.length; i++) {
        var match = this.matches[i];

        if (match.player1 == player || match.player2 == player)
        {
            return true;
        }
    }

    return false;
};

Player.prototype.getMatches = function () {
    return this.matches.length;
    /* var n = 0;
    for (var i = 0; i < this.matches.length; i++) {
        var match = this.matches[i];

        if (match.player1 == this || match.player2 == this) n++;
    }

    return n;*/
};

Player.prototype.getMatchesWhite = function () {
    var n = 0;
    for (var i = 0; i < this.matches.length; i++) {
        var match = this.matches[i];

        if (match.player1 == this) n++;
    }

    return n;
};

Player.prototype.getMatchesBlack = function () {
    var n = 0;
    for (var i = 0; i < this.matches.length; i++) {
        var match = this.matches[i];

        if (match.player2 == this) n++;
    }

    return n;
};

Player.prototype.getVs = function (round) {
    for (var i = this.matches.length; i >= 0; i--) {
        var match = this.matches[i];

        if (
            match &&
            match.round == round
        ) {
            if (match.player1 == this)
                return match.player2;
            if (match.player2 == this)
                return match.player1;
        }
    }

    return false;
};

Player.prototype.hasPlayed = function (round) {
    for (var i = this.matches.length; i >= 0; i--) {
        var match = this.matches[i];

        if (
            match &&
            match.round == round &&
            (match.player1 == this || match.player2 == this)
        )
            return true;
    }

    return false;
};

function createNextSwiss(round1, numRonda) 
{
    var playerList = [];
    
}

function Resultados(playerList)
{
    //-- Calcular buchholz
    for (var i = 0; i < playerList.length; i++) {
        var player1 = playerList[i];
        for (var ii = 0; ii < playerList.length; ii++) {
            var player2 = playerList[ii];
            if (player1 == player2) {
                continue;
            }
            if (player1.hasPlayedAgainst(player2)) {
                player1.buchholz += player2.score;
            }
        }
    }

    playerList.sort(function (player1, player2) {
        return player2.score*player2.buchholz - player1.score*player1.buchholz;
    });
    console.log("---------------", "Resultados", "---------------");
    
    for (var i = 0; i < playerList.length; i++) {
        var player = playerList[i];
        console.log(
            "Puesto",
            i + 1,
            ":",
            player.name,
            "con",
            player.score,
            "puntos",
            "y",
            "buchholz", player.buchholz,
            "y",
            "elo", player.elo,
            "y",
            player.getMatches(),
            "partidas + ",
            player.notpair, "descanso",
            player.getMatchesWhite(),
            "con blancas y",
            player.getMatchesBlack(),
            "con negras"
        );
        /* if (player.getMatches() != Match.RONDAS && (playerList.length) % 2 == 0) {
            console.error('Error en el sorteo', player)
            // break
        }

        if (player.getMatches() < Match.RONDAS - 1 && (playerList.length) % 2 != 0) {
            console.error('Error en el sorteo', player)
            // break
        }*/
    }
}

function createSwiss(players, round1, numRonda) 
{
    var playerList = [];
    // window.alert(JSON.stringify(players));
    for (var i in players) {
        console.log(i, players[i].name, players[i].juega);
        if (players[i].juega === true) {
          playerList.push(new Player(players[i].name, players[i].score, players[i].elo));
        }
    }
    
    var matchPossible = true;
    console.log("Jugadores:", playerList.length);
    console.log("Rondas:", Match.RONDAS);

    //-- Primera ordenación
    //-- Orden alfabetico con la misma puntuación y elo
    playerList.sort(function (player1, player2) {
        if (player2.score == 0 && player1.score == 0)
        {
            return player2.elo - player1.elo;
        }
        return player2.score*player2.buchholz - player1.score*player1.buchholz;
    });

    var round = {};
    var rondaRoundRobin = {};
    // if (numRonda == 0)
    // window.alert(JSON.stringify(round1));
    if (round1[0] != undefined)
    {
        console.log("--------------- poniendo puntos", "---------------");
        // window.alert(JSON.stringify(round1));
        for (var r in round1) {
            if (round1[r] != undefined) 
            {
                var bNotFinish = false;
                for (var partida in round1[r].rounds)
                {
                    // window.alert(round1[r].rounds[round].white);
                    var player1 = playerList[0];
                    for (var i = 0; i < playerList.length; i++) {
                        player1 = playerList[i];
                        if (round1[r].rounds[partida].white == player1.name)
                        {
                            break;
                        }
                    }
                    var player2 = playerList[0];
                    for (var i = 0; i < playerList.length; i++) {
                        player2 = playerList[i];
                        if (round1[r].rounds[partida].black == player2.name)
                        {
                            break;
                        }
                    }
                    if (player1 && player2 && round1[r].rounds[partida].wins != '')
                    {
                        var result = Match.RESULT_WIN;
                        if (round1[r].rounds[partida].wins == 'white')
                            result = Match.RESULT_WIN;
                        else if (round1[r].rounds[partida].wins == 'black')
                            result = Match.RESULT_LOSS;
                        else if (round1[r].rounds[partida].wins == 'draw')
                            result = Match.RESULT_DRAW;
                        new Match(numRonda, player1, player2, result);
                        // var partida = {white: player1.name, black: player2.name, wins: round1[r].rounds[partida].wins}
                        // round[i] = partida
                    }
                    else
                    {
                        // window.alert(player1.name + 'vs' + player2.name, ' ', result);
                        bNotFinish = true;
                        break;
                    }
                }
                // window.alert(numRonda + ' ' + bNotFinish);
                // var roundaux = { rounds: round };
                
                if (bNotFinish == false)
                    numRonda++;
            }
            
        }
        rondaRoundRobin = round1;
        // window.alert(JSON.stringify(round1));
        // window.alert(JSON.stringify(rondaRoundRobin));
        // Resultados(playerList);
    }
    Resultados(playerList);
    if (bNotFinish == true)
    {
        if (window.confirm('No ha finalizado la ronda: ' + (numRonda + 1) + ' ¿Forzar finalización?')) {
            numRonda = numRonda + 1
        }
        else 
        {
            // window.alert('No ha finalizado la ronda: ' + (numRonda + 1));
            rondaRoundRobin = round1;
            // rondaRoundRobin.id = Math.random();
            return rondaRoundRobin;
        }
    }
    
    {
        // window.alert(numRonda);
        if (numRonda == 0)
        {
            console.log("--------------- Ronda ", numRonda, "---------------");
            var round = {};
            for (var i = 0; i < Math.round(playerList.length / 2); i++) {
                var player1 = playerList[i];

                matchFound = false;
                for (var ii = Math.round(playerList.length / 2); ii < playerList.length; ii++) {
                    var player2 = playerList[ii];
                    
                    if (player1 == player2) {
                        continue;
                    }
                    if (player2.hasPlayed(numRonda)) {
                        continue;
                    }
                    matchFound = true;
                    //-- sorteo del color inicial
                    // window.alert('match')
                    new Match(numRonda, player1, player2, Match.randomResult());
                    var partida = {white: player1.name, black: player2.name, wins: '' }
                    round[i] = partida
                    break;
                }

                if (matchFound == false && (playerList.length + 1) % 2 == 0) {
                    player1.notpair++;
                    console.log("Descansa", player1.name, player1.notpair, "veces");
                }
            }
            // window.alert('fin ' + numRonda)
            var roundaux = { rounds: round };
            rondaRoundRobin[numRonda] = roundaux;
            // rondaRoundRobin.id = Math.random();
            // window.alert(JSON.stringify(rondaRoundRobin));
            return rondaRoundRobin;
        }
        else 
        {
            // round++;
            while (matchPossible) {
                matchPossible = false;
                //-- Calcular buchholz
                for (var i = 0; i < playerList.length; i++) {
                    var player1 = playerList[i];
                    for (var ii = 0; ii < playerList.length; ii++) {
                        var player2 = playerList[ii];
                        if (player1 == player2) {
                            continue;
                        }
                        if (player1.hasPlayedAgainst(player2)) {
                            player1.buchholz += player2.score;
                        }
                    }
                }
                playerList.sort(function (player1, player2) {
                    return player2.score*player2.buchholz - player1.score*player1.buchholz;
                });
                var max = 0;
                console.log("--------------- Round ", numRonda, "---------------");
                matchesCount = 0;
                var noencontrado = 0;
                var round = {}
                for (var i = 0; i < playerList.length; i++) {
                    var player1 = playerList[i];
                    max++;
                    // console.log('Emparejando', player1.name);
                    if (max > 5000)
                        break;
                    /*if( player1.matches.length > round ) {
                    
                        continue;
                    }*/

                    if (player1.hasPlayed(numRonda)) {
                        //console.log('jugado', player2.name)
                        continue;
                    }
                    var matchFound = false;

                    //-- Busca rival
                    for (var ii = 0; ii < playerList.length; ii++) {
                        var player2 = playerList[ii];
                        // console.log('\tProbando con ', player2.name);
                        /*if( player2.matches.length > round ) {
                        continue;
                        }*/
                        if (player1 == player2) {
                            continue;
                        }
                        /*if( player2.matches.length > round ) {
                            continue;
                        }*/

                        if (player1.hasPlayedAgainst(player2)) {
                            continue;
                        }

                        if (player2.hasPlayed(numRonda)) {
                            // console.log('jugado', player2.name)
                            continue;
                        }
                        /*
                        if( Math.abs( player1.score - player2.score ) > MAX_SCORE_DIFFERENCE ) {
                            continue;
                        }*/

                        matchPossible = true;

                        var partida = {white: '', black: '', wins: ''};
                        if (player1.getMatchesWhite() <= player2.getMatchesWhite()) {
                            new Match(numRonda, player1, player2, Match.randomResult());
                            partida = {white: player1.name, black: player2.name, wins: ''}
                        } else {
                            new Match(numRonda, player2, player1, Match.randomResult());
                            partida = {white: player2.name, black: player1.name, wins: ''}
                        }
                        round[i] = partida;
                        // window.alert(JSON.stringify(round))
                        
                        matchFound = true;
                        break;
                    }

                    if (matchFound == false && (playerList.length) % 2 != 0) {
                        if (player1.notpair == 0) {
                            player1.notpair++;
                            console.log("Descansa", player1.name);
                            break;
                        } else {
                            console.log(noencontrado, "Ya ha descansado antes", player1.name);
                            for (var i = 1; i < playerList.length; i++) {
                                var player = playerList[playerList.length - i];
                                if (player != undefined && player != player1 && player.notpair == 0 && player1.hasPlayedAgainst(player) == false
                                    && player.getVs(numRonda).notpair == 0) {
                                    player.popMatch(numRonda)
                                    var partida = {white: '', black: '', wins: ''};
                                    if (player1.getMatchesWhite() <= player.getMatchesWhite()) {
                                        new Match(numRonda, player1, player, Match.randomResult());
                                        partida = {white: player1.name, black: player.name, wins: ''}
                                    } else {
                                        new Match(numRonda, player, player1, Match.randomResult());
                                        partida = {white: player.name, black: player2.name, wins: ''}
                                    }
                                    round[i] = partida
                                    matchesCount--;
                                    matchFound = true;
                                    break;
                                }
                            }
                        }
                    }

                    if (matchFound == false && (playerList.length) % 2 == 0) 
                    {
                        if (player1.notpair == 0) {
                            // player1.notpair++;
                            console.log("No encuentro pareja para", player1.name);
                        } else {
                            // console.log(noencontrado, "Ya ha descansado antes",player1.name);
                        }
                        for (var i = 1; i < playerList.length; i++) {
                            var player = playerList[playerList.length - i];
                            if (player != undefined && player1.hasPlayedAgainst(player) == false && player != player1) {
                                player.popMatch(numRonda)
                                matchesCount--;
                                var partida = {white: '', black: '', wins: ''};
                                if (player1.getMatchesWhite() <= player.getMatchesWhite()) {
                                    new Match(numRonda, player1, player, Match.randomResult());
                                    partida = {white: player1.name, black: player.name, wins: ''}
                                } else {
                                    new Match(numRonda, player, player1, Match.randomResult());
                                    partida = {white: player.name, black: player.name, wins: ''}
                                }
                                round[i] = partida

                                break;
                            }
                        }
                        matchPossible = true;
                        i = 0;
                        continue;
                    }
                }

                var roundaux = { rounds: round };
                rondaRoundRobin[numRonda] = roundaux;
                //rondaRoundRobin.id = Math.random();
                // window.alert('fin2 ' + numRonda)
                // window.alert(JSON.stringify(rondaRoundRobin));
                return rondaRoundRobin;

                /* break;
                numRonda++;
                if (numRonda > Match.RONDAS - 1)
                    break;*/
            }

            
        
            
        }
    }
    return rondaRoundRobin;
}

module.exports.createSwiss = createSwiss


// WEBPACK FOOTER //
// ./src/services/swiss.js